import { ISyncOptions } from '@/utils/ISyncOptions';

export default {
  startup: async (): Promise<void> => {
    
  },
  syncOperations: async (): Promise<void> => {
    
  }
} as ISyncOptions;